import { Module } from 'vuex'
import { RootState } from '../store-types'
import { useFeedbackStatsHttp } from '@/core/api/feedback-stats'
import { FeedbackStat, FeedbackStatPayload } from '@/core/models/feedback-stat'

const state: FeedbackStat = new FeedbackStat(<FeedbackStatPayload>{})

export const feedbackStat: Module<FeedbackStat, RootState> = {
    namespaced: true,
    state,
    mutations: {
        update: (state: FeedbackStat, payload: FeedbackStatPayload) => {
            state.fill(payload)
        }
    },
    actions: {
        get: <T>(context: any, payload: any): Promise<T> => {
            state.unset()
            return new Promise<T>((resolve, reject) => {
                useFeedbackStatsHttp()
                    .get(payload)
                    .then((data: any) => {
                        context.commit('update', data.data)
                        resolve(data as T)
                    })
                    .catch((response: any) => {
                        reject(response as T)
                    })
            })
        },
    },
    getters: {
        get: (state: FeedbackStat): FeedbackStat => {
            return state
        }
    }
}